import type { HtmlProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

export function HtmlInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as HtmlProps;

  return (
    <>
      <div
        style={{
          padding: "0 16px 8px",
          fontSize: 11,
          color: "var(--fg-dim)",
          lineHeight: 1.5,
        }}
      >
        Pasted HTML is rendered verbatim. Use for embeds (YouTube, Twitter, analytics) and
        custom markup. Avoid user-supplied input.
      </div>
      <TextField
        label="HTML"
        value={p.html}
        onChange={(v) => update(widget.id, { html: v })}
        multiline
      />
    </>
  );
}
